import { ThemeModule } from '../../front/lib/ThemeModule';
import { theme } from '../../front/Theme';
import { createApp } from 'vue';
import SHSearchApp from './SHSearchApp.vue';
export class SiteHeader extends ThemeModule {
    init() {
        if (theme().isPrintMode()) {
            return;
        }
        const search = this.initSearch();
        const mobileMenu = this.initMobileMenu();
        this.initAutoDuck({
            canDuck: () => !search.appInstance.resultsVisible && !mobileMenu.isMenuOpen(),
        });
    }
    initSearch() {
        const searchAppEl = this.getElementById('searchApp');
        const searchControlsEl = this.getElementById('searchControls');
        const app = createApp(SHSearchApp, {
            searchControleMountPoint: searchControlsEl,
            report: {
                searchActive: (val) => {
                    val ? this.root.classList.add('is--searchActive') : this.root.classList.remove('is--searchActive');
                },
            },
        });
        app.use(theme().i18n);
        const appInstance = app.mount(searchAppEl);
        return { app, appInstance };
    }
    initMobileMenu() {
        const hamburger = this.root.querySelector('.hamburger');
        const menuWrapper = this.root.querySelector('.siteHeaderMod-menu-wrapper');
        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('is-active');
            menuWrapper.classList.toggle('is--open');
        });
        return {
            isMenuOpen: () => menuWrapper.classList.contains('is--open'),
        };
    }
    /**
     * Hides header automatically when user scrolls up.
     *
     * This implementation allows for some leeway when scrolling both ways to avoid excessive toggling.
     * Note that distance is reset after some time to begin tracking new delta value
     */
    initAutoDuck(args) {
        const THRESHOLD_SCROLL_UP = -100;
        const THRESHOLD_SCROLL_DOWN = 100;
        const WAIT_FOR_SCROLL_MS = 500;
        let distanceDelta = 0;
        let prevScrollY = window.scrollY;
        let resetter = null;
        const reset = () => {
            distanceDelta = 0;
            prevScrollY = window.scrollY;
            if (resetter) {
                window.clearTimeout(resetter);
            }
            if (window.scrollY < this.root.offsetHeight) {
                removeHiddenState();
            }
        };
        const removeHiddenState = () => {
            this.root.classList.remove('is--hidden');
            document.body.style.removeProperty('--site-content-top-offset');
        };
        const setHiddenState = () => {
            this.root.classList.add('is--hidden');
            document.body.style.setProperty('--site-content-top-offset', 'var(--s-wp-adminBar-height)');
        };
        window.addEventListener('scroll', event => {
            // Test if header is in the state where it must not be ducked
            // E.g. when some of the menus are open
            if (typeof (args === null || args === void 0 ? void 0 : args.canDuck) === 'function') {
                if (!args.canDuck()) {
                    removeHiddenState();
                    return;
                }
            }
            distanceDelta = Math.max(THRESHOLD_SCROLL_UP, Math.min(THRESHOLD_SCROLL_DOWN, distanceDelta + (window.scrollY - prevScrollY)));
            prevScrollY = window.scrollY;
            if (distanceDelta <= THRESHOLD_SCROLL_UP) {
                removeHiddenState();
            }
            else if (distanceDelta >= THRESHOLD_SCROLL_DOWN) {
                setHiddenState();
            }
            if (resetter) {
                window.clearTimeout(resetter);
            }
            resetter = window.setTimeout(reset, WAIT_FOR_SCROLL_MS);
        }, { passive: true });
    }
}
